import { clearOfflineActions } from '../../scene/crop-management/crop/store/actions/offline.actions'
import { OfflineState, QueuedOfflineAction } from '../../scene/crop-management/crop/store/reducers/offline.reducer'
import { Injectable, inject } from '@angular/core'
import { Store } from '@ngrx/store'
import { requireDefined } from '@agroone-front/shared'
import { Observable, debounceTime, forkJoin, from, map, of, switchMap, toArray } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class OfflineService {
  private store = inject<Store<OfflineState>>(Store)

  syncOfflineActions(actions?: QueuedOfflineAction[]): Observable<void> {
    return from(requireDefined(actions, 'the offline actions')).pipe(
      map((action) => {
        if (action?.action) {
          return of(this.store.dispatch(action?.action))
        }
        return of([])
      }),
      toArray(),
      switchMap((actions) => forkJoin(actions)),
      debounceTime(100),
      switchMap(() => of(this.store.dispatch(clearOfflineActions()))),
    )
  }
}
